/**
 * Validates redirect URLs against allowed origins to prevent Open Redirect (CWE-601).
 */

const ALLOWED_ORIGINS: string[] = (
  process.env.REACT_APP_ALLOWED_REDIRECT_ORIGINS ||
  "https://universe.tvs.in,https://universe.tvs.in"
)
  .split(",")
  .map((o) => o.trim())
  .filter(Boolean);

/**
 * Checks if a given redirect URL belongs to a trusted/allowed origin.
 * Returns the URL if valid, or a fallback URL if invalid.
 */
export function validateRedirectUrl(
  redirectUrl: string | null | undefined,
  fallback: string = ""
): string {
  if (!redirectUrl || !redirectUrl.trim() || redirectUrl === "undefined") {
    return fallback;
  }

  try {
    const parsed = new URL(redirectUrl);

    // Only allow http/https protocols
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return fallback;
    }

    // Check if origin matches any allowed origin
    const origin = parsed.origin;
    const isAllowed = ALLOWED_ORIGINS.some((allowed) => {
      try {
        return origin === new URL(allowed).origin;
      } catch {
        return false;
      }
    });

    return isAllowed ? redirectUrl : fallback;
  } catch {
    return fallback;
  }
}
